var React = require('react');

function ShortRightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M6.43089319,20.4014559 C6.71815532,20.6887181 7.07170872,20.8323491 7.49155337,20.8323491 C7.91139802,20.8323491 8.26495141,20.6887181 8.55221354,20.4014559 L17.0374949,11.9161746 L8.55221354,3.43089319 C8.26495141,3.14363106 7.91139802,3 7.49155337,3 C7.07170872,3 6.71815532,3.14363106 6.43089319,3.43089319 C6.14363106,3.71815532 6,4.07170872 6,4.49155337 C6,4.91139802 6.14363106,5.26495141 6.43089319,5.55221354 L12.7948542,11.9161746 L6.43089319,18.2801356 C6.14363106,18.5673977 6,18.9209511 6,19.3407958 C6,19.7606404 6.14363106,20.1141938 6.43089319,20.4014559 Z"}));
}

ShortRightArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ShortRightArrow;

ShortRightArrow.default = ShortRightArrow;
